import { requestParentNavigation } from '../postMessage';

// A second tap while the host is still deciding must not post a second
// request or open two cashier tabs.
let isPending = false;

/**
 * Sends the player to the casino cashier. The host gets the first say
 * (`navigate_deposit`) — app WebViews open their own deposit screen. If it
 * doesn't claim it, opens the cashier in a NEW tab so the game (and any
 * in-progress round) stays alive; on return the wallet re-reads the balance
 * via `visibilitychange` and the player simply retries.
 */
export function openDepositUrl(url: string): void {
  if (isPending) return;
  isPending = true;
  void requestParentNavigation('navigate_deposit').then((isHandled) => {
    isPending = false;
    if (!isHandled) openCashier(url);
  });
}

/**
 * Falls back to navigating the top window when the popup is blocked
 * (sandboxed iframe without `allow-popups`, or a browser that no longer
 * counts the tap as a user gesture after the host round-trip), and gives up
 * silently if that is blocked too.
 */
function openCashier(url: string): void {
  let opened: Window | null = null;
  try {
    opened = window.open(url, '_blank', 'noopener,noreferrer');
  } catch {
    opened = null;
  }
  if (opened) return;
  try {
    (window.top ?? window).location.assign(url);
  } catch {
    // Top navigation blocked by the host sandbox — nothing safe left to do.
  }
}
